import React from 'react'
import './../ButtonStyle.css'
const PrimaryButton = ({onClick,isdisabled,children,classname}) => {
  return (
    <button className={classname} onClick={onClick} disabled={isdisabled}>{children}</button>
  )
}

export default PrimaryButton;